/**
 * Layout content component
 * 
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class Content extends PureComponent {

	static propTypes = {
		
		children: PropTypes.node,
	}
	
	render() {
		
		const { children } = this.props;

		return (
			
	        <div className="layout-content">
				{children}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/layout/content/content.js